export { DeleteContact, ContactType } from './src/delete-invoice-contact';
